<template>
	<span>
		<button v-if="description" class="linkButton sourceTooltip risk" :class="riskClass" v-tooltip.click="description">{{status}}</button>
		<span class="sourceLink risk" :class="riskClass" v-else>{{status}}</span>
	</span>	
</template>
<script>

	export default {
		name: 'StatusTooltip',
		props: ['status'],
		data() {
			return {
				descriptions: {
					Unverified: 'This breach is still being processed and its authenticity verified.',
        			Verified: 'This breach has been verified by Authlogics, our customers, and partners.',
        			Unreliable: 'This breach has been identitifed as having information that may not be accurate or reliable.'
				},
				risks: {
					Unverified: 'medium',
        			Verified: 'none',
        			Unreliable: 'high'
				},
				description: '',
				riskClass: ''
			}
		},
		mounted() {
			this.update(this.status);
		},
		methods: {
			update(value) {
				this.riskClass = this.risks[value];
				this.description = this.descriptions[value];
			}
		},
		watch: {
			//Tooltip isnt naturally reactive, so update the description when the prop changes
			source(value) {
				this.update(value);
			}
		}	
	}
</script>


// WEBPACK FOOTER //
// src/components/StatusTooltip.vue